import OrdersManagementModule from '@/modules/orders-management';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/orders')({
  component: OrdersPage,
});

function OrdersPage() {
  return <OrdersManagementModule />;
}
